"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccepters = exports.withDefaultAccepterName = void 0;
var GetLetter_1 = require("../GroupAccept/GetLetter");
var withDefaultAccepterName = function (accepters) {
    return accepters.map(function (accepter, index) {
        if (accepter.name !== null && !!accepter.name) {
            return accepter;
        }
        return __assign(__assign({}, accepter), { name: "Accepter ".concat((0, GetLetter_1.getLetter)(index)) });
    });
};
exports.withDefaultAccepterName = withDefaultAccepterName;
var getAccepters = function (blockSettings) {
    var accepters = [];
    for (var i = 0; i < blockSettings.number; i++) {
        var prefilledName = blockSettings.prefilledNames[i];
        if (blockSettings.enablePrefilledNames && prefilledName) {
            var name = prefilledName;
            accepters.push({ name: name });
        }
        else {
            accepters.push({ name: "Accepter ".concat((0, GetLetter_1.getLetter)(i)) });
        }
    }
    return accepters;
};
exports.getAccepters = getAccepters;
